import { User } from './../shared/services/user';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LedgerEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';

declare var require: any
@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.css']
})

export class LedgerComponent implements OnInit {
  totalCashFlow: number;
  lead = {};
  leadTimeAlt = 0;
  rateAlt = 0;
  constructor(public authService: AuthService, private db: AngularFirestore, public ledgerService: LedgerService) {
    //this.ledgerService.getLedger();
  }
  ngOnInit() {
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    this.getLedger();
    this.setUser();
  }
  setUser() {
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.LedgerEntry.user = this.userProfile.displayName;
    this.LedgerEntry.userEmail = this.userProfile.email;
    this.LedgerEntry.userNumber = this.userProfile.number;
    this.LedgerEntry.userId = this.user.uid;
  }
  userProfile: User;
  user;
  addingNew = true;
  backup = false;
  fullView = false;

  ledger: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;

  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  newShipment: boolean = false;
  newSupplier: boolean = false;
  rate; leadTime;
  entryToEdit: any = {};
  autoComplete = {
    TXN: {},
    supplier: {},
    shipmentNumber: {},
    codeCredit: {},
    codeDebit: {},
    creditName: {},
    date: {},
    debitName: {},
  };
  autoCompleteKeys = {
    TXN: {},
    supplier: {},
    shipmentNumber: {},
    codeCredit: {},
    codeDebit: {},
    creditName: {},
    debitName: {},
    date: {},
  };
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = [];
  LedgerEntry: LedgerEntry = {
    id: "",
    TXN: "",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "",
    codeDebit: "",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }
  supplierShipments = {};
  generalLedgerCollection = { generalLedger: [] };
  show = true;
  addNew() {
    // if (this.addingNew) {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l12";
    //   this.addingNew = !this.addingNew;
    // } else {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l10";
    //   this.addingNew = !this.addingNew;

    // }
  }
  getDate(element) {
    let unix_timestamp = element['seconds']
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    return new Date(unix_timestamp * 1000);
  }
  formatDate(date) {
    var today = this.getDate(date); //console.log(date);
    var res = "";
    res = today.toString();

    // this should be safe since nothing else in the date string contains a opening paren
    var index = res.indexOf("GMT");

    // if the index exists
    if (~index) {
      res = res.substr(0, index);
    }
    return res;
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;

  }
  ready = false;
  getLedger() {
    // this.show = true;
    this.ledger = this.db.collection("generalLedger", ref => ref.orderBy("date", "desc")).snapshotChanges().pipe(map(actions => {
      this.totalDebit = 0; this.totalCredit = 0; this.totalCashFlow = 0; this.show = true; this.ready = true;
      return actions.map(a => {
        //Get document data
        const data = a.payload.doc.data() as LedgerEntry;
        this.totalDebit += this.roundValue(data.debitValue);
        this.totalCredit += this.roundValue(data.creditValue);
        this.totalCashFlow += this.roundValue(data.cashFlow);
        this.supplierShipments[data.supplier] = {};
        this.supplierShipments[data.supplier][data.shipmentNumber] = true;
        //Get document id
        const id = a.payload.doc.id;

        //console.log(data);
        this.addAutoComplete(data)
        this.generalLedgerCollection.generalLedger.push(data);
        let date = this.formatDate(data.date);

        // Will display time in 10:30:23 format
        // var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        Math.abs(2 % 2) == 1
        //Use spread operator to add the id to the document data
        data.date=this.getDate(data.date)
return { id, date, data };
      });
    }));
  }
  isToday(dateParameter) {
    var today = new Date();
  //  console.log("is today?", dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear());

    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  getLeadTime() {
    //let leadTime = 0;// ref => ref.where('supplier', '==', supplier)
    let collection = this.db.collection("generalSupplier", ref => ref.where('supplier', '==', this.LedgerEntry.supplier))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.leadTimeAlt = data.leadTime;
          this.lead[data.supplier] = { leadTime: data.leadTime, supplier: data.supplier, rates: {} };
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    collection = this.db.collection("generalShipments", ref => ref.where('supplier', '==', this.LedgerEntry.supplier).where('shipmentNumber', '==', this.LedgerEntry.shipmentNumber))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          // console.log(data.rate);
          this.rateAlt = data.rate;
          this.lead[data.supplier].rates[data.shipmentNumber] = data.rate;
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    
  }
  confirm(s) {
    return confirm(s)
  }
  updateValueOnAutocomplete() {
    if (this.LedgerEntry.supplier != "") {
      if (this.supplierShipments[this.LedgerEntry.supplier]) {
        if (this.LedgerEntry.shipmentNumber != 0 && !this.supplierShipments[this.LedgerEntry.supplier][this.LedgerEntry.shipmentNumber]) {
          this.newShipment = true; this.newSupplier = false;
        } else {
          this.newShipment = false; this.newSupplier = false;
          this.getLeadTime();
        }
      } else {
        this.newShipment = true;
        this.newSupplier = true;
      }
    } else {
      this.newShipment = false; this.newSupplier = false;

    }
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];

      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;

      if (val) {
        if (key != 'shipmentNumber') {
          if (key == 'date') {
            me.LedgerEntry[key] = new Date(val);
          }
          else
            me.LedgerEntry[key] = val;
        }
        else {
          me.LedgerEntry[key] = Number.parseFloat(val);
        }
        //console.log(me.LedgerEntry[key]);
      }
      //


    });
  }
  addAutoComplete(data) {
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "") {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);

      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  filterLedgerFromServerByText(): void {
    this.updateValueOnAutocomplete();
    //console.log("filter called");

    let supplier = this.LedgerEntry.supplier;
    let shipmentNumber = this.LedgerEntry.shipmentNumber;
    let txn = this.LedgerEntry.TXN;
    let date = this.LedgerEntry.date;
    let dbCode = this.LedgerEntry.codeDebit;
    let crCode = this.LedgerEntry.codeCredit;
  //  console.log("filter", supplier, shipmentNumber, txn, date, dbCode, crCode);
    if (supplier == "" && this.safeToFilter) {
      this.getLedger();
      if ((!this.isToday(date) || this.autoCompleteArray.includes(txn) || this.autoCompleteArray.includes(dbCode) || this.autoCompleteArray.includes(crCode)) && this.safeToFilter) {
        //console.log("filterstart");
        let db = this.db;//handle case zero ? ask dad ?
        let collection = db.collection("generalLedger");
        if (txn != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('TXN', '==', txn))
        }
        if (dbCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('codeDebit', '==', dbCode))
        }
        if (crCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('codeCredit', '==', crCode))
        }
        if (crCode != "" && dbCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('codeCredit', '==', crCode).where('codeDebit', '==', dbCode))
        }
        if (!this.isToday(date)) {
        //  console.log(date);
          collection = db.collection("generalLedger", ref => ref.where('date', '>=', date))
        }
        this.ledger = collection.snapshotChanges().pipe(map(actions => {
          this.totalDebit = 0; this.totalCredit = 0; this.totalCashFlow = 0;
          return actions.map(a => {
            //Get document data
            const data = a.payload.doc.data() as LedgerEntry;
            this.totalDebit += this.roundValue(data.debitValue);
            this.totalCredit += this.roundValue(data.creditValue);
            this.totalCashFlow += this.roundValue(data.cashFlow);
            //Get document id
            const id = a.payload.doc.id;
            //console.log(data);
            let date = this.formatDate(data.date);
            //Use spread operator to add the id to the document data
            data.date=this.getDate(data.date)
return { id, date, data };
          });
        }));
      }
      return;
    } //console.log("filter check", this.autoCompleteArray.includes(supplier) && this.safeToFilter, this.autoCompleteArray , supplier, this.safeToFilter);
    if (this.autoCompleteArray.includes(supplier) && this.safeToFilter) {
      //console.log("filterstart");
      let db = this.db;//handle case zero ? ask dad ?
      let collection = db.collection("generalLedger");
      if (shipmentNumber == 0) {
        collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier))
      }
      else {
        collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber));
        if (txn != "") {
        //  console.log("txn called");
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('TXN', '==', txn))
        }
        if (txn != "" && dbCode != "") {
        //  console.log("txn called");
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('TXN', '==', txn).where('codeDebit', '==', dbCode))
        }
        if (txn != "" && crCode != "") {
        //  console.log("txn called");
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('TXN', '==', txn).where('codeCredit', '==', crCode))
        }
        if (txn != "" && dbCode != "" && crCode != "") {
        //  console.log("txn called");
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('TXN', '==', txn).where('codeDebit', '==', dbCode).where('codeCredit', '==', crCode))
        }
        if (dbCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', dbCode))
        }
        if (crCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', crCode))
        }
        if (dbCode != "" && crCode != "") {
          collection = db.collection("generalLedger", ref => ref.orderBy("date", "desc").where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', dbCode).where('codeCredit', '==', crCode))
        }

        if (!this.isToday(date)) {
          collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('date', '>=', date))
        }

      }

      this.ledger = collection.snapshotChanges().pipe(map(actions => {
        this.totalDebit = 0; this.totalCredit = 0; this.totalCashFlow = 0;
        return actions.map(a => {
          //Get document data
          const data = a.payload.doc.data() as LedgerEntry;
          this.totalDebit += this.roundValue(data.debitValue);
          this.totalCredit += this.roundValue(data.creditValue);
          this.totalCashFlow += this.roundValue(data.cashFlow);
          //Get document id
          const id = a.payload.doc.id;
          //console.log(data);
          let date = this.formatDate(data.date);
          //Use spread operator to add the id to the document data
          data.date=this.getDate(data.date)
return { id, date, data };
        });
      }));
    }


  }
  editEntry(ledgerEntry, id) {
  //  console.log(ledgerEntry, id);
    //Set taskToEdit and editMode
    this.LedgerEntry = ledgerEntry;
    window.scrollTo(0, 0);
    this.editMode = true;
    this.entryToEdit.id = id;
    //Set form value
    //this.myEntry = ledgerEntry.description;
  } //edit
  saveEntry() {
    if (this.LedgerEntry.codeCredit !== "" && this.LedgerEntry.codeDebit !== "") {//add ledger entry checks
      //Get the input value
      //balance values
      this.LedgerEntry.debitValue = this.LedgerEntry.creditValue;
      if (!this.editMode) {
        //console.log(this.LedgerEntry);
        this.ledgerService.addTask(this.LedgerEntry);
        this.newShipment ? this.ledgerService.addShipment(this.LedgerEntry, this.rate) : null
        this.newSupplier ? this.ledgerService.addSupplier(this.LedgerEntry, this.leadTime) : null
      } else {
        //Get the entry id
        let taskId = this.entryToEdit.id;
        //update the entry
        this.ledgerService.updateTask(taskId, this.LedgerEntry);
      }
      //set edit mode to false and clear form
      this.editMode = false;
      this.entryToEdit = {};
      this.LedgerEntry = {
        id: "",
        TXN: "",
        supplier: "",
        shipmentNumber: 0,
        codeCredit: "",
        codeDebit: "",
        creditName: "",
        creditValue: 0,
        date: new Date(),
        debitName: "",
        debitValue: 0,
        cashFlow: 0,
        comment: "",
        user: "",
        userId: "",
        userEmail: "",
        userNumber: "",
      }
      this.myEntry = "";
      this.getLedger();
    }
  } //saveTask
  deleteTask(entry) {
    if (confirm('Are you sure you want to delete this item?')) {
      //Get the entry id
      let taskId = entry.id;
      //delete the entry
      this.ledgerService.deleteTask(taskId);
    }
  } //deleteTask

  convertFile(csv: any) {
    this.safeToFilter = false;
    this.fileReaded = csv.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);

    reader.onload = (e) => {
      let csv = reader.result.toString(); //console.log(csv)
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(',');
      let lines = [];
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma  
        let data = allTextLines[i].split(',');
        // log each row to see output  
        if (data.length > 1)
          lines.push(data);
      }
      //skip header start from one
      for (let i = 0; i < lines.length; i++) {
        //check if debitr or credit entry
        let debitflag = true;
        if (lines[i][5].length == 0 && lines[i][6].length > 0)
          debitflag = !debitflag;
        //create ledger entry 
        this.safeToFilter = false;
        this.LedgerEntry.TXN = lines[i][0];
        this.LedgerEntry.supplier = lines[i][1];
        if (lines[i][2] != "")
          this.LedgerEntry.shipmentNumber = parseInt(lines[i][2]);
        else
          this.LedgerEntry.shipmentNumber = 0;
        // this.LedgerEntry.date = new Date();
        // this.LedgerEntry.userId = this.authService.getUser.uid;
        // this.LedgerEntry.user = this.authService.getUserProfile.displayName;

        if (debitflag) {
          this.LedgerEntry.codeDebit = lines[i][3];
          this.LedgerEntry.debitName = lines[i][10];
          this.LedgerEntry.debitValue = parseFloat(lines[i][5]);
          if (lines[i][7] != "") {
            this.LedgerEntry.cashFlow = parseFloat(lines[i][7]);
          }
          this.LedgerEntry.comment = lines[i][8];
        }
        else {
          this.LedgerEntry.codeCredit = lines[i][3];
          this.LedgerEntry.creditName = lines[i][10];
          this.LedgerEntry.creditValue = parseFloat(lines[i][6]);

          //console.log(this.LedgerEntry);
          this.saveEntry();
          this.LedgerEntry = {
            id: "",
            TXN: "",
            supplier: "",
            shipmentNumber: 0,
            codeCredit: "",
            codeDebit: "",
            creditName: "",
            creditValue: 0,
            date: new Date(),
            debitName: "",
            debitValue: 0,
            cashFlow: 0,
            comment: "",
            user: "",
            userId: "",
            userEmail: "",
            userNumber: "",
          }
          this.rate = 0;
          this.leadTime = 0;
          this.setUser();
          this.getLedger();
          this.safeToFilter = true;
        }

      }
      // all rows in the csv file  
      //console.log("", lines);
    }
  }

  exportJSON() {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(this.generalLedgerCollection)], { type: 'application/json' });
    a.href = URL.createObjectURL(file);
    a.download = 'backup.json';
    a.click();
    //https://firebase.google.com/docs/firestore/manage-data/export-import
    //console.log("https://firebase.google.com/docs/firestore/manage-data/export-import");
  }
  importJSON(csv: any) {
    this.safeToFilter = false;
    this.fileReaded = csv.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    //console.log(reader.result)
    reader.onload = (e) => {

      let result = reader.result.toString();
      let json = JSON.parse(result);
      //console.log(json)
      for (let i = 0; i < json["generalLedger"].length; i++) {

        this.LedgerEntry = json["generalLedger"][i];
        // Object.keys(json["generalLedger"]).forEach(function (key) {

        //   this.LedgerEntry[key] = json["generalLedger"][i][key];
        // });
        //console.log(this.LedgerEntry)
        this.saveEntry();
        this.LedgerEntry = {
          id: "",
          TXN: "",
          supplier: "",
          shipmentNumber: 0,
          codeCredit: "",
          codeDebit: "",
          creditName: "",
          creditValue: 0,
          date: new Date(),
          debitName: "",
          debitValue: 0,
          cashFlow: 0,
          comment: "",
          user: "",
          userId: "",
          userEmail: "",
          userNumber: "",
        }
        this.safeToFilter = true;
      }
    }
  }
}
